export default __webpack_public_path__ + "static/media/bed07.e15d3526.png";